import { makeStyles } from '@mui/styles';
const darkGray = '#263238';

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginBottom: theme.spacing(2),
      boxShadow: 'none',
      border: '1px solid #cfd8dc',
      borderRadius: 4,
      minWidth: 280,
      background: '#f7f8f8',
      padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
      cursor: 'initial !important',
      boxSizing: 'border-box',
      margin: 0,
      '&.current-device': {
        borderColor: theme.palette.primary.main,
      },
    },
    // Cofirm Dialog
    list: {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    listItems: {
      textAlign: 'right',
      padding: 0,
      marginBottom: 0,
      wordBreak: 'break-all',
    },

    logo: {
      width: 80,
      height: 80,
      objectFit: 'contain',
      background: 'white',
      padding: theme.spacing(1),
      border: `1px solid #cfd8dc`,
      borderRadius: 5,
      // marginBottom: -theme.spacing(0.6)
    },
    keyTitlePart: {
      marginInlineEnd: 'auto',
      marginInlineStart: theme.spacing(2),
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(2),
        marginInlineStart: theme.spacing(0.5),
      },
    },
    keyTitle: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'bold',
    },
    keyDesc: {
      fontSize: 12,
      color: '#546e7a',
      fontWeight: 'regular',
      marginTop: 8,
    },
    clientPart: {
      marginInlineEnd: 'auto',
      marginInlineStart: theme.spacing(2),
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(1),
        marginInlineStart: theme.spacing(0.5),
      },
    },
    clientTitle: {
      fontSize: 14,
      color: darkGray,
      fontWeight: 'bold',
      '& span': {
        color: '#78909c',
        marginInlineStart: theme.spacing(1),
      },
    },
    currentDevice: {
      fontSize: 13,
      color: darkGray,
      fontWeight: 'normal',
      paddingTop: theme.spacing(0.4),
      // color: theme.palette.primary.main
    },
    clientDesc: {
      fontSize: 14,
      color: darkGray,
      fontWeight: '400',
      fontFamily: 'Vazir',
      marginTop: 8,
    },
    copyIcon: {
      width: 20,
      height: 20,
      color: '#78909c',
      marginInlineStart: theme.spacing(1),
      marginTop: -2,
    },
    actions: {
      marginInlineStart: 'auto',
      marginInlineEnd: theme.spacing(2),
      [theme.breakpoints.down('lg')]: {
        marginInlineEnd: 'auto',
        marginInlineStart: 'initial',
        marginTop: theme.spacing(2),
      },
    },
    expandBtn: {
      // border: `1px solid #cfd8dc`,
      padding: theme.spacing(2),
      // marginInlineEnd: theme.spacing(2),
      // background: 'white'
    },
    actionsIcon: {
      marginInlineStart: theme.spacing(1.5),
      color: '#7d8f9b',
      padding: theme.spacing(1),
    },
    // Key Details
    details: {
      borderTop: '1px solid #cfd8dc',
      background: '#eceff1',
      paddingTop: 0,
      paddingBottom: 0,
    },
    detailsContainer: {
      paddingInlineEnd: theme.spacing(2),
      paddingInlineStart: theme.spacing(0),
      width: 'calc(100% - 85px)',
      marginInlineStart: 'auto',
    },
    detailRow: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      borderBottom: `1px solid #b0bec5`,
      '&:last-child': {
        border: 'none',
      },
    },
    property: {
      fontSize: 14,
      color: darkGray,
      fontWeight: '400',
    },
    propertyIcon: {
      fontSize: 25,
      color: '#d1d8dc',
      marginInlineEnd: theme.spacing(1),
      '&.active': {
        color: '#508b46',
      },
    },
    partTitle: {
      fontSize: 14,
      color: darkGray,
      fontWeight: 'bold',
      '& span': {
        color: '#78909c',
        marginInlineStart: theme.spacing(1),
      },
    },
    showPassBtn: {
      color: '#006cfc',
      marginInlineStart: theme.spacing(-1),
      fontSize: 14,
      fontWeight: '400',
    },
    passText: {
      fontSize: 14,
      color: darkGray,
      fontWeight: '300',
      fontFamily: 'Vazir',
      paddingTop: theme.spacing(0.8),
      paddingInlineStart: theme.spacing(1),
      letterSpacing: theme.spacing(0.2),
    },
    scopeItem: {
      display: 'inline-block',
      color: darkGray,
      fontSize: 14,
      fontFamily: 'Vazir',
      background: '#cfd8dc',
      fontWeight: '300',
      padding: `${theme.spacing(0.7)} ${theme.spacing(1.6)} ${theme.spacing(
        0.4,
      )} ${theme.spacing(1.6)}`,
      lineHeight: 'initial',
      marginInlineEnd: 5,
      borderRadius: 3,
      marginBottom: 5,
    },
    addressItem: {
      color: darkGray,
      fontSize: 14,
      fontFamily: 'Vazir',
      fontWeight: '300',
      lineHeight: 'initial',
      marginInlineEnd: 5,
      marginBottom: 5,
    },
    deviceIcon: {
      color: '#263238',
      fontSize: 30,
      // display: 'inline-flex'
    },
  };
});
